import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import lock from "../../../Assets/Images/lock.png";
import TabContainer from "../../../Component/Common/TabContainer";

// function TabContainer(props) {
//   return <Typography component="div">{props.children}</Typography>;
// }

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: theme.palette.background.paper
  },
  grow: {
    flexGrow: 1,
  },
  inputRoot: {
    width: "100%",
  },
  inputInput: {
    borderRadius: 50,
    border: 1,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
});

class ChangePasswordSucess extends React.Component {
  state = {};

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div className="width100" align="center">
        <div>
          <img className="lockPng" src={lock} alt="icon" height="20" />
        </div>
        <div>
          <div className="lockMsg">

            <FormattedMessage id="MsgSuccess" defaultMessage="successfully changed your account's password." />
          </div>
        </div>
      </div>
    );
  }
}
ChangePasswordSucess.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChangePasswordSucess);
